<template>
  <div class="extension-restoration">
    <div class="page-header">
      <h1 class="main-title">学签延期Extension与恢复Restoration</h1>
      <div class="sub-title">学习签证</div>
    </div>

    <div class="content-section">
      <p class="intro-text">
        学签在到期90天后无效，学签延期应在学签到期前30天申请。如果在学签到期前提交了延期的申请，则被称为 "Implied status"，即 "等待状态"。即使学签过期仍然被允许继续学习，只要符合以下条件：
      </p>

      <div class="section">
        <h2>延期条件</h2>
        <ul class="condition-list">
          <li>在当前学签到期前提交了Renew申请。</li>
          <li>从学签到期一直都在加拿大。</li>
          <li>继续符合学签规定的条件。</li>
        </ul>
      </div>

      <div class="section">
        <h2>特殊情况说明</h2>
        <p class="special-note">
          如果学生在"等待状态"期间离开了加拿大，你必须以为临时居民重新入境，提供他们的100号TRV档案（IR190）或多次往返签证。但是他们不可以在加拿大开始学习，直到他们拿到他们的学签renew。入境时需要上学签renew申请，表明申请正在处理过程中。
        </p>
      </div>

      <div class="section">
        <h2>如果学签已经过期</h2>
        <ul class="expired-list">
          <li>
            <strong>情况一：</strong>
            如果在学签到期之前申请了延期，但尚未收到延期申请结果的决定，则可以继续在加拿大，因为保持了自己临时居民的身份。也可以继续学习，直到收到延期申请结果的决定。
          </li>
          <li>
            <strong>情况二：</strong>
            如果未申请延期，则将失去在加拿大的学生身份。在恢复身份以外学签之前，不能继续学习习或重新开始新的学习。
          </li>
        </ul>

        <div class="restoration-info">
          <p>
            恢复学生身份的条件在学签到期后收到延期拒绝信后的90天内提交申请。在未得到恢复学生身份的批准之前，不可以参加学习。如果正在学习，则必须立即停止学习。只有在收到了恢复学生身份的批准后，才可以参加学习。
          </p>
        </div>

        <div class="important-note">
          <p>
            注意：只有在加拿大境内才能恢复学生身份。如果在延期申请期间离开加拿大，身份将无法恢复，必须在加拿大境外申请新的学签或重复等待IRCC出出学签延期决定后，才能返回加拿大继续学习（英美除除外）
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExtensionRestorationView'
}
</script>

<style scoped>
.extension-restoration {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.page-header {
  text-align: center;
  margin-bottom: 3rem;
}

.main-title {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.sub-title {
  font-size: 1.2rem;
  color: #666;
}

.content-section {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.intro-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #444;
  margin-bottom: 2rem;
}

.section {
  margin-bottom: 2.5rem;
}

.section h2 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #eee;
}

.condition-list,
.expired-list {
  list-style: none;
  padding: 0;
}

.condition-list li,
.expired-list li {
  margin-bottom: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  position: relative;
  padding-left: 2rem;
}

.condition-list li::before {
  content: '✓';
  position: absolute;
  left: 0.7rem;
  color: #28a745;
}

.expired-list li strong {
  color: #dc3545;
  display: block;
  margin-bottom: 0.5rem;
}

.special-note,
.restoration-info,
.important-note {
  padding: 1.5rem;
  border-radius: 6px;
  margin: 1.5rem 0;
}

.special-note {
  background: #e9ecef;
  border-left: 4px solid #6c757d;
}

.restoration-info {
  background: #f8f9fa;
  border-left: 4px solid #28a745;
}

.important-note {
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  color: #856404;
}
</style>